let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9bYpA")).then(() => parcelRequire('kfIPw'));